import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Variables } from "../../../Variations/Variations";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { BiTrash } from "react-icons/bi";
import { Modal } from "react-bootstrap";
import ProductManageAttributeValues from "./ProductManageAttributeValues";

const ProductAttributes = (props) => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [AttributeId, setAttributeId] = useState("");

  // Save all current selections
  const handleSaveAttributes = () => {
    props.setSavedAssigned(props.productSelectedAttributes);
    toast.success("Saved Successfully");
  };

  // Update a specific attribute's values
  const handleAttributeValueChange = (selectedOptions, index) => {
    try {
      const updated = [...props.productSelectedAttributes];
      updated[index] = {
        ...updated[index],
        AttributeValues: selectedOptions || []
      };
      props.setProductSelectedAttributes(updated);
    } catch (error) {
      toast.error(error.message);
    }
  };

  // Delete an attribute group
  const DeleteAttribute = (i) => {
    const updated = [...props.productSelectedAttributes];
    updated.splice(i, 1);
    props.setProductSelectedAttributes(updated);
  };

  // Add a new attribute by ID
  const handleAddAttribute = () => {
    fetch(
      `${Variables.API_URL}Attributes/GetAttributeDetailsByAttributeID/${props.ddlSelectedAttribute}`
    )
      .then((res) => res.json())
      .then((result) => {
        if (result) {
          const newAttr = {
            AttributeId: result[0].AttributeId,
            AttributeName: result[0].AttributeName,
            AttributeValues: [],
            AllAttributeValues: result[0].AllAttributeValues,
          };
          props.setProductSelectedAttributes([
            ...props.productSelectedAttributes,
            newAttr,
          ]);
          props.setAttributesList(
            props.attributesList.filter(
              (item) => item.AttributeId !== props.ddlSelectedAttribute
            )
          );
          props.setDdlSelectedAttribute(0);
        }
      })
      .catch((err) => toast.error(err.message));
  };

  // Handle attribute dropdown change
  const handleSelectedAttribute = (e) => {
    props.setDdlSelectedAttribute(e.target.value);
  };

  // Select all values for given attribute
  const AssignAllAttributesValues = (id) => {
    const updated = props.productSelectedAttributes.map((attr) =>
      attr.AttributeId === id
        ? { ...attr, AttributeValues: attr.AllAttributeValues }
        : attr
    );
    props.setProductSelectedAttributes(updated);
  };

  // Deselect all values for given attribute
  const UnAssignAllAttributesValues = (id) => {
    const updated = props.productSelectedAttributes.map((attr) =>
      attr.AttributeId === id
        ? { ...attr, AttributeValues: [] }
        : attr
    );
    props.setProductSelectedAttributes(updated);
  };

  // Fetch assigned values on load
  const GetAssignedProductAttributesValues = () => {
    fetch(
      `${Variables.API_URL}Attributes/GetAssignedProductAttributesValues/${props.ProductID}`
    )
      .then((res) => res.json())
      .then((result) => {
        if (result !== "0") {
          props.setProductSelectedAttributes(result);
          props.setSavedAssigned(result);
          GetAttributesList();
        }
      });
  };

  // Fetch remaining attributes for dropdown
  const GetAttributesList = () => {
    fetch(`${Variables.API_URL}Attributes/GetAttributeDetails`)
      .then((res) => res.json())
      .then((list) => {
        const filtered = list.filter(
          (item) =>
            !props.savedAssigned.some(
              (saved) => saved.AttributeId === item.AttributeId
            )
        );
        props.setAttributesList(filtered);
      });
  };

  // Initial load
  useEffect(() => {
    // get existing attribute IDs, details, and values
    props.selectedAttributes.forEach((attr) => {
      // any pre-load logic if needed
    });
    GetAttributesList();
    if (props.ProductID) {
      GetAssignedProductAttributesValues();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="row linked item">
      <div className="col-lg-12 mb-3">
        <div className="row">
          <div className="col-lg-10">
            <select
              className="form-select"
              value={props.ddlSelectedAttribute}
              onChange={handleSelectedAttribute}
            >
              <option value="0">-- Select --</option>
              {props.attributesList.map((opt) => (
                <option key={opt.AttributeId} value={opt.AttributeId}>
                  {opt.AttributeName}
                </option>
              ))}
            </select>
          </div>
          <div className="col-lg-2">
            <button className="btn btn-primary w-100" onClick={handleAddAttribute}>
              +
            </button>
          </div>
        </div>
      </div>

      <div className="col-lg-12">
        {props.productSelectedAttributes.map((data, i) => (
          <div key={data.AttributeId} className="card mb-3 p-3">
            <div className="d-flex justify-content-between mb-2">
              <strong>{data.AttributeName}</strong>
              <BiTrash
                className="text-danger"
                style={{ cursor: "pointer" }}
                onClick={() => DeleteAttribute(i)}
              />
            </div>

            <Select
              isMulti
              options={data.AllAttributeValues}
              value={data.AttributeValues}
              getOptionLabel={(o) => o.AttributeValueName}
              getOptionValue={(o) => String(o.AttributeValueId)}
              onChange={(opts) => handleAttributeValueChange(opts, i)}
              className="mb-2"
            />

            <div className="btn-group">
              <button
                className="btn btn-light"
                onClick={() => AssignAllAttributesValues(data.AttributeId)}
              >
                Select All
              </button>
              <button
                className="btn btn-light"
                onClick={() => UnAssignAllAttributesValues(data.AttributeId)}
              >
                None
              </button>
              <button
                className="btn btn-light"
                onClick={() => {
                  setShow(true);
                  setAttributeId(data.AttributeId);
                }}
              >
                Add New
              </button>
            </div>

            <Modal show={show} fullscreen onHide={() => setShow(false)}>
              <Modal.Header closeButton>
                <Modal.Title>Add Attribute Value</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <ProductManageAttributeValues AttributeId={AttributeId} />
              </Modal.Body>
            </Modal>
          </div>
        ))}
      </div>

      {props.productSelectedAttributes.length > 0 && (
        <div className="col-lg-12 text-end">
          <button className="btn btn-success" onClick={handleSaveAttributes}>
            Save Attributes
          </button>
        </div>
      )}

      <ToastContainer />
    </div>
  );
};

export default ProductAttributes;
